'use strict';

var getParamByName = require('../../lib/getParamByName.js');
var $ = window.jQuery;


function FileList() {
	var filterEl = document.getElementsByClassName('categoryFilter');
	
	if (!filterEl.length)
		return;
	
	var active = 'category--active';
	var query = getParamByName('template');
	if (query) {
		// Change dropdown to queried selection
		$('.categoryFilter select').val(query);

		// Clear previous selection
		$('.category-group').removeClass(active);

		// Add active to queried template div
		var selected = '.category-' + $('.categoryFilter select').val();
		$(selected).addClass(active);
	}

	$('select').change(function() {
		// Change dropdown to queried selection
		$('.category-group').removeClass(active);

		// Add active to queried template div
		var selected = '.category-' + $('.categoryFilter select').val();
		$(selected).addClass(active);
	})
} // FileList()

module.exports = {
	init: FileList
}